import { render, staticRenderFns } from "./SetupTeams.vue?vue&type=template&id=14419d36&scoped=true"
import script from "./SetupTeams.vue?vue&type=script&lang=js"
export * from "./SetupTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14419d36",
  null
  
)

export default component.exports